import business from './business'
import customer from './customer'
import powerRanking from './powerRanking'
import equipmentFailureRate from './equipmentFailureRate'
import equipmentFailureStatus from './equipmentFailureStatus'
import equipmentType from './equipmentType'
import transactionFlow from './transactionFlow'
export default {
    business,
    customer,
    powerRanking,
    equipmentFailureRate,
    equipmentFailureStatus,
    equipmentType,
    transactionFlow
}


// WEBPACK FOOTER //
// ./src/views/dataIndex/data/index.js